import {
  convertToGutterSheetMeasurements,
  convertToStringArray,
  transformImages,
} from "./utiles";

export const genratePayloadForSalesForceApi=(leadDetail,gutterSheet,leafFilterSheet)=>{
const fullName = leadDetail?.name || '';
const nameParts = fullName.trim().split(' ');

const firstName = nameParts[0] || '';
const lastName = nameParts.slice(1).join(' ') || '';

   let finnalPorchCeiling=gutterSheet?.porchCeiling?.map(
    (item, index) => ({
      Gutter_Sheet_porch_Ceiling_location: item.location || "",
      Gutter_Sheet_porch_Ceiling_length: item.length === "" ? 0 : Number(item.length),
      Gutter_Sheet_porch_Ceiling_width: item.width === "" ? 0 : Number(item.width),
      Gutter_Sheet_porch_Ceiling_squareFeet:
        item.length === "" || item.width === "" ? 0 : item.length * item.width,
      Gutter_Sheet_porch_Ceiling_squareFeetCostPrice:item.length === "" || item.width === "" ? 0 : (item.length * item.width) * 8,
      Gutter_Sheet_porch_Ceiling_squareFeetRetailPrice:item.length === "" || item.width === "" ? 0 : (item.length * item.width) * 16,
    })
  );
  const payload = {
  leadId: leadDetail?.leadId,
  customer: {
    firstName,
    lastName,
    fullName,
    city: leadDetail?.city,
    state: leadDetail?.state,
    street: leadDetail?.address,
  },
  gutterSheet: !gutterSheet ? null : {
    new_Miterr_Box_Inside: Number(gutterSheet?.newMeterInside),
    new_Miter_Box_OutSide: Number(gutterSheet?.newMeterOutside),
    Gutter_Sheet_Measurements: convertToGutterSheetMeasurements(
      gutterSheet?.measurements
    ),
    Ribbed_Roof_Quantity: gutterSheet?.ribbedRoofQuantity,
    roof: {
      // Gutter_Sheet_Fascia_Total_Footage: gutterSheet?.costPricing?.fasciaTotalFootage || 0, /// what is this?
      Gutter_Sheet_roofType: convertToStringArray(gutterSheet?.roof?.roofType),
      Gutter_Sheet_FutterType: gutterSheet?.roof?.gutterType,
      Gutter_Sheet_GutterColor: gutterSheet?.roof?.gutterColor,
      Gutter_Sheet_GutterSize: gutterSheet?.roof?.gutterSize, ////in api mentioned string
      Gutter_Sheet_Total_Gutter_Footage: Number(gutterSheet?.roof?.totalGutterFootage),
      Gutter_Sheet_Downspout_Type: gutterSheet?.roof?.downSpout,
      Gutter_Sheet_Downspout_Color: gutterSheet?.roof?.downSpoutColor,
      Gutter_Sheet_downspout_footage:
        gutterSheet?.roof?.downSpoutFootage?.totalFootage,
      Gutter_Sheet_downSpout_Footage: {
        Gutter_Sheet_ofAElbows: Number(gutterSheet?.roof?.downSpoutFootage?.ofAElbows),
        Gutter_Sheet_ofBElbows: Number(gutterSheet?.roof?.downSpoutFootage?.ofBElbows),
        Gutter_Sheet_ofRoundElbows: Number(gutterSheet?.roof?.downSpoutFootage?.ofRoundElbows),
        Gutter_Sheet_ofOffsetElbows: Number(gutterSheet?.roof?.downSpoutFootage?.ofOffsetElbows),
        Gutter_Sheet_total_Footage_Gutter_Downspouts_Elbows: gutterSheet?.roof?.sumOfAllFootage,
      },
    },
    misc: {
      Gutter_Sheet_Miters_Outside: Number(gutterSheet?.misc?.ofMitersOutside),
      Gutter_Sheet_Miters_Inside: Number(gutterSheet?.misc?.ofMitersInside),
      Gutter_Sheet_Endcaps_Right: Number(gutterSheet?.misc?.ofEndcapsRights),
      Gutter_Sheet_Endcaps_Left: Number(gutterSheet?.misc?.ofEndcapsLefts),
      Gutter_Sheet_Spout_Savers: Number(gutterSheet?.misc?.ofSproutSavers),
      Gutter_Sheet_Roof_Straps: Number(gutterSheet?.misc?.ofRoofStraps),
      Gutter_Sheet_Wedges: Number(gutterSheet?.misc?.ofwedges),
    },
    Gutter_Sheet_partialInstall: gutterSheet?.misc?.partialInstall,
    Gutter_Sheet_fasciaReplacement: {
      Gutter_Sheet_type: gutterSheet?.fasciaReplacement?.type,
      Gutter_Sheet_fascia_Replacement_Footage:
        Number(gutterSheet?.fasciaReplacement?.totalFootage),
      Gutter_Sheet_Facsia_Total_Footage:
        Number(gutterSheet?.fasciaReplacement?.totalFootage),
      Gutter_Sheet_facsia_size: gutterSheet?.fasciaReplacement?.size,
      Gutter_Sheet_fascia_product_Type:
        gutterSheet?.fasciaReplacement?.productType,
      Gutter_Sheet_product_Detail:
        gutterSheet?.fasciaReplacement?.productDetail,
      Gutter_Sheet_totalFtOfNewWrap:
        gutterSheet?.fasciaReplacement?.totalFtOfNewWrap,
      Gutter_Sheet_Fascia_wrap_color: gutterSheet?.fasciaReplacement?.wrapColor, /// what is this?
      Gutter_Sheet_Fascia_wrap_metalWrappedColor:
        gutterSheet?.fasciaReplacement?.fascia_color,
    },
    Gutter_Sheet_Soffit_Replacement: {
      Gutter_Sheet_Soffit_replacement_Type:
        gutterSheet?.soffitReplacement?.replacementType,
      Gutter_Sheet_Soffit_totalFootage:
        Number(gutterSheet?.soffitReplacement?.totalFootage),
      Gutter_Sheet_Type_soffitType: gutterSheet?.soffitReplacement?.soffitType,
      Gutter_Sheet_Color_soffitColor:
        gutterSheet?.soffitReplacement?.soffitColor,
    },
    Gutter_Sheet_porchCeiling:finnalPorchCeiling,
    metalWrappedColor: gutterSheet?.metalWrappedColor,
    Gutter_Sheet_costPricing: {
      Gutter_Sheet_first_Story_Total: Number(gutterSheet?.costPricing?.firstStoryTotal || 0),
      Gutter_Sheet_second_Story_Total: Number(gutterSheet?.costPricing?.secondStoryTotal || 0),
      Gutter_Sheet_third_Story_Total: Number(gutterSheet?.costPricing?.thirdStoryTotal || 0),
      Gutter_Sheet_total_Gutter_Footage: Number(gutterSheet?.costPricing?.totalGutterFootage || 0),
      Gutter_Sheet_downspout_Footage: Number(gutterSheet?.costPricing?.downspoutFootage || 0),
      Gutter_Sheet_A_Elbows: Number(gutterSheet?.costPricing?.aElbows || 0),
      Gutter_Sheet_B_Elbows: Number(gutterSheet?.costPricing?.bElbows || 0),
      Gutter_Sheet_total_Gutter_Downspout_Elbows: Number(gutterSheet?.costPricing?.totalGutterDownspoutElbows || 0),
      Gutter_Sheet_Wedges: Number(gutterSheet?.costPricing?.ofWedges || 0),
      Gutter_Sheet_fascia_Total_Footage: Number(gutterSheet?.costPricing?.fasciaTotalFootage || 0),
      Gutter_Sheet_total_feet_New_Wrap: Number(gutterSheet?.costPricing?.totalFTOfNewWrap || 0),
      Gutter_Sheet_soffit_Total_Footage: Number(gutterSheet?.costPricing?.soffitTotalFootage || 0),
      Gutter_Sheet_new_Miter_Inside:  0,
      Gutter_Sheet_new_Miter_OutSide:  0,
    },
    Gutter_Sheet_retail_Pricing: {
      Gutter_Sheet_firstStoryTotal: Number(gutterSheet?.retailPricing?.firstStoryTotal || 0),
      Gutter_Sheet_secondStoryTotal: Number(gutterSheet?.retailPricing?.secondStoryTotal || 0),
      Gutter_Sheet_thirdStoryTotal: Number(gutterSheet?.retailPricing?.thirdStoryTotal || 0),
      Gutter_Sheet_totalGutterFootage:  Number(gutterSheet?.retailPricing?.totalGutterFootage || 0),
      Gutter_Sheet_downspoutFootage: Number(gutterSheet?.retailPricing?.downspoutFootage || 0),
      Gutter_Sheet_A_Elbows: Number(gutterSheet?.retailPricing?.aElbows || 0),
      Gutter_Sheet_B_Elbows: Number(gutterSheet?.retailPricing?.bElbows || 0),
      Gutter_Sheet_total_Gutter_Downspout_Elbows: Number(gutterSheet?.retailPricing?.totalGutterDownspoutElbows || 0),
      Gutter_Sheet_Wedges: Number(gutterSheet?.retailPricing?.ofWedges || 0),
      Gutter_Sheet_fascia_Total_Footage:  Number(gutterSheet?.retailPricing?.fasciaTotalFootage || 0),
      Gutter_Sheet_total_feet_New_Wrap: Number(gutterSheet?.retailPricing?.totalFTOfNewWrap || 0),
      Gutter_Sheet_soffit_Total_Footage: Number(gutterSheet?.retailPricing?.soffitTotalFootage || 0),
      Gutter_Sheet_New_Miter_Inside: Number(gutterSheet?.retailPricing?.newMeterInside || 0),
      Gutter_Sheet_new_Miter_OutSide: Number(gutterSheet?.retailPricing?.newMeterOutSide || 0),
    },
    Gutter_Sheet_par_Price: gutterSheet?.parPrice || 0,
    Gutter_Sheet_costPrice: gutterSheet?.costPrice || 0,
    Gutter_Sheet_RetailPrice: gutterSheet?.RetailPrice || 0,
    Gutter_Sheet_results: {
      Gutter_Sheet_resultType: leadDetail?.results?.resultType || "Demo",
      Gutter_Sheet_resultReason:
        leadDetail?.results?.resultReason || "Didn't Like",
      Gutter_Sheet_oneLeg: leadDetail?.results?.oneLeg || "mr",
      Gutter_Sheet_lastPrice: leadDetail?.results?.lastPrice || 0,
    },
    Gutter_Sheet_gutter_height: leadDetail?.gutterHeight,
    Gutter_Sheet_Images: gutterSheet?.images || [],
  },
  leafFilterSheet: !leafFilterSheet ? null : {
    Leaf_Filter_Sheet_AElbows: leafFilterSheet?.AElbows,
    Leaf_Filter_Sheet_BElbows: leafFilterSheet?.BElbows,
    Leaf_Filter_Sheet_color: leafFilterSheet?.color || "Clay",
    Leaf_Filter_Sheet_csr: leafFilterSheet?.csr,
    Leaf_Filter_Sheet_existing_Gutter_Color:
      leafFilterSheet?.existingGutterColor,
    Leaf_Filter_Sheet_existing_Protection: leafFilterSheet?.existingProtection,
    Leaf_Filter_Sheet_existing_Protection_Type:
      leafFilterSheet?.existingProtectionType,
    Leaf_Filter_Sheet_extension_Protection_Footage:
      leafFilterSheet?.existingProtectionTypeValue,
    Leaf_Filter_Sheet_extensions_Needed: leafFilterSheet?.extensionsNeeded,
    Leaf_Filter_Sheet_groundspout_Needed: leafFilterSheet?.groundSpoutNeeded,
    Leaf_Filter_Sheet_Gutter_Opening_Width: leafFilterSheet?.gutterOpeningWidth,
    Leaf_Filter_Sheet_gutter_Profile_type: leafFilterSheet?.gutterProfile,
    Leaf_Filter_Sheet_hasSheet: false,
    Leaf_Filter_Sheet_inside_Corners: leafFilterSheet?.insideCorners,
    Leaf_Filter_Sheet_ladders_needed: leafFilterSheet?.ladders,
    Leaf_Filter_Sheet_leaf_Filter_Color: "Clay",
    Leaf_Filter_Sheet_leaf_Filter_Profile_type:
      leafFilterSheet?.leafFilterProfile,
    Leaf_Filter_Sheet_versa_Max_Quantity_feet: leafFilterSheet?.versaMaxValue,
    Leaf_Filter_Sheet_measurements: [
      {
        label: "Left_Side_of_Home",
        first_Story: leafFilterSheet?.measurements[0]?.firstStory,
        second_Story: leafFilterSheet?.measurements[0]?.secondStory,
        third_Story: leafFilterSheet?.measurements[0]?.thirdStory,
      },
      {
        label: "Right Side of Home",
        first_Story: leafFilterSheet?.measurements[1]?.firstStory,
        second_Story: leafFilterSheet?.measurements[1]?.secondStory,
        third_Story: leafFilterSheet?.measurements[1]?.thirdStory,
      },
      {
        label: "Front of Home",
        first_Story: leafFilterSheet?.measurements[2]?.firstStory,
        second_Story: leafFilterSheet?.measurements[2]?.secondStory,
        third_Story: leafFilterSheet?.measurements[2]?.thirdStory,
      },
      {
        label: "Rear of Home",
        first_Story: leafFilterSheet?.measurements[3]?.firstStory,
        second_Story: leafFilterSheet?.measurements[3]?.secondStory,
        third_Story: leafFilterSheet?.measurements[3]?.thirdStory,
      },
      {
        label: "Garage",
        first_Story: leafFilterSheet?.measurements[4]?.firstStory,
        second_Story: leafFilterSheet?.measurements[4]?.secondStory,
        third_Story: leafFilterSheet?.measurements[4]?.thirdStory,
      },
      {
        label: "Other",
        first_Story: leafFilterSheet?.measurements[5]?.firstStory,
        second_Story: leafFilterSheet?.measurements[5]?.secondStory,
        third_Story: leafFilterSheet?.measurements[5]?.thirdStory,
      },
      {
        label: "Total",
        first_Story: leafFilterSheet?.measurements[6]?.firstStory,
        second_Story: leafFilterSheet?.measurements[6]?.secondStory,
        third_Story: leafFilterSheet?.measurements[6]?.thirdStory,
      },
      {
        label: "R & RR Total",
        first_Story: leafFilterSheet?.measurements[7]?.firstStory,
        second_Story: leafFilterSheet?.measurements[7]?.secondStory,
        third_Story: leafFilterSheet?.measurements[7]?.thirdStory,
      },
    ],
    Leaf_Filter_Sheet_Fastener_Type_lenght:leafFilterSheet?.mountingLength,
    Leaf_Filter_Sheet_Fastener_Type:leafFilterSheet?.mountingType,
    Leaf_Filter_Sheet_Note_Bottom: leafFilterSheet?.note,
    Leaf_Filter_Sheet_Wallboard_obstruction: leafFilterSheet?.obstruction,
    Leaf_Filter_Sheet_outside_Corners: leafFilterSheet?.outsideCorners,
    Leaf_Filter_Sheet_partial: leafFilterSheet?.partial,
    Leaf_Filter_Sheet_results: {
      Leaf_Filter_Sheet_resultType: leadDetail?.results?.resultType || "Demo",
      Leaf_Filter_Sheet_resultReason: leadDetail?.results?.resultReason || "Didn't Like",
      Leaf_Filter_Sheet_oneLeg: leadDetail?.results?.oneLeg || "mr",
      Leaf_Filter_Sheet_lastPrice: leadDetail?.results?.lastPrice || 0,
    },
    Leaf_Filter_Sheet_roof: leafFilterSheet?.roof,
    Leaf_Filter_Sheet_spring_clips_color: leafFilterSheet?.roofColor,
    Leaf_Filter_Sheet_roofType: leafFilterSheet?.roofType, //in api mentioned array
    sizes: leafFilterSheet?.sizes,
    Leaf_Filter_Sheet_spout_Saver_Quantity: leafFilterSheet?.spoutSaverQuantity,
    Leaf_Filter_Sheet_state: leafFilterSheet?.state,
    totalFootage: leafFilterSheet?.totalFootage,
    units: leafFilterSheet?.units,
    Leaf_Filter_Sheet_walkboards: leafFilterSheet?.walkboards,
    Leaf_Filter_Sheet_retail_Pricing: {
      Leaf_Filter_Sheet_first_Story_Total_Column_1: leafFilterSheet?.retailPricing?.firstStoryTotal1,
      Leaf_Filter_Sheet_first_Story_Total_Column_2: leafFilterSheet?.retailPricing?.firstStoryTotal2,
      Leaf_Filter_Sheet_second_Story_Total_Column_1: leafFilterSheet?.retailPricing?.secondStoryTotal1,
      Leaf_Filter_Sheet_second_Story_Total_Column_2: leafFilterSheet?.retailPricing?.secondStoryTotal2,
      Leaf_Filter_Sheet_third_Story_Total_Column_1: leafFilterSheet?.retailPricing?.thirdStoryTotal1,
      Leaf_Filter_Sheet_third_Story_Total_Column_2: leafFilterSheet?.retailPricing?.thirdStoryTotal2,
      Leaf_Filter_Sheet_first_Story_RR_Total_Column_1: leafFilterSheet?.retailPricing?.firstStoryRAndRTotal1,
      Leaf_Filter_Sheet_first_Story_RR_Total_Column_2: leafFilterSheet?.retailPricing?.firstStoryRAndRTotal2,
      Leaf_Filter_Sheet_second_Story_RR_Total_Column_1: leafFilterSheet?.retailPricing?.secondStoryRAndRTotal1,
      Leaf_Filter_Sheet_second_story_RR_Total_Column_2: leafFilterSheet?.retailPricing?.secondStoryRAndRTotal2,
      Leaf_Filter_Sheet_third_story_RR_Total_Column_1: leafFilterSheet?.retailPricing?.thirdStoryRAndRTotal1,
      Leaf_Filter_Sheet_third_story_RR_Total_Column_2: leafFilterSheet?.retailPricing?.thirdStoryRAndRTotal2,
      first_Story_RR_totalFootage: leafFilterSheet?.retailPricing?.totalFootage,
      Leaf_Filter_Sheet_clean_Seal_Reinforce: leafFilterSheet?.retailPricing?.cleanSealReinforce,
      Leaf_Filter_Sheet_Inside_Corners: leafFilterSheet?.retailPricing?.ofInsideCorners,
      Leaf_Filter_Sheet_OutSide_Corners: leafFilterSheet?.retailPricing?.ofOutSideCorners,
      Leaf_Filter_Sheet_typeCost: leafFilterSheet?.retailPricing?.typeCost,
      Leaf_Filter_Sheet_extensions_Needed_Footage: leafFilterSheet?.retailPricing?.extensionsNeededFootage,
      Leaf_Filter_Sheet_Groundspout_units: leafFilterSheet?.retailPricing?.units,
      Leaf_Filter_Sheet_A_Elbows: leafFilterSheet?.retailPricing?.ofAElbows,
      Leaf_Filter_Sheet_B_Elbows: leafFilterSheet?.retailPricing?.ofBElbows,
      Leaf_Filter_Sheet_size_details:leafFilterSheet?.retailPricing?.sizes,
      Leaf_Filter_Sheet_versa_Max_Quantity: leafFilterSheet?.retailPricing?.versaMaxQuantity,
      Leaf_Filter_Sheet_fastener_Type: leafFilterSheet?.retailPricing?.fastenerType,
    },
    costPricing: {
      Leaf_Filter_Sheet_first_Story_Total_Column_1: leafFilterSheet?.costPricing?.firstStoryTotal1,
      Leaf_Filter_Sheet_first_Story_Total_Column_2: leafFilterSheet?.costPricing?.firstStoryTotal2,
      Leaf_Filter_Sheet_second_Story_Total_Column_1: leafFilterSheet?.costPricing?.secondStoryTotal1,
      Leaf_Filter_Sheet_second_Story_Total_Column_2: leafFilterSheet?.costPricing?.secondStoryTotal2,
      Leaf_Filter_Sheet_third_Story_Total_Column_1: leafFilterSheet?.costPricing?.thirdStoryTotal1,
      Leaf_Filter_Sheet_third_Story_Total_Column_2: leafFilterSheet?.costPricing?.thirdStoryTotal2,
      Leaf_Filter_Sheet_first_Story_RR_Total_Column_1: leafFilterSheet?.costPricing?.firstStoryRAndRTotal1,
      Leaf_Filter_Sheet_first_Story_RR_Total_Column_2: leafFilterSheet?.costPricing?.firstStoryRAndRTotal2,
      Leaf_Filter_Sheet_second_Story_RR_Total_Column_1: leafFilterSheet?.costPricing?.secondStoryRAndRTotal1,
      Leaf_Filter_Sheet_second_Story_RR_Total_Column_2: leafFilterSheet?.costPricing?.secondStoryRAndRTotal2,
      Leaf_Filter_Sheet_third_story_RR_Total_Column_1: leafFilterSheet?.costPricing?.thirdStoryRAndRTotal1,
      Leaf_Filter_Sheet_third_story_RR_Total_Column_2: leafFilterSheet?.costPricing?.thirdStoryRAndRTotal2,
      first_Story_RR_totalFootage: leafFilterSheet?.costPricing?.totalFootage,
      Leaf_Filter_Sheet_clean_Seal_Reinforce: leafFilterSheet?.costPricing?.cleanSealReinforce,
      Leaf_Filter_Sheet_Inside_Corners: leafFilterSheet?.costPricing?.ofInsideCorners,
      Leaf_Filter_Sheet_OutSide_Corners: leafFilterSheet?.costPricing?.ofOutSideCorners,
      Leaf_Filter_Sheet_typeCost: leafFilterSheet?.costPricing?.typeCost,
      Leaf_Filter_Sheet_extensions_Needed_Footage: leafFilterSheet?.costPricing?.extensionsNeededFootage,
      Leaf_Filter_Sheet_Groundspout_units: leafFilterSheet?.costPricing?.units,
      Leaf_Filter_Sheet_A_Elbows: leafFilterSheet?.costPricing?.ofAElbows,
      Leaf_Filter_Sheet_B_Elbows: leafFilterSheet?.costPricing?.ofBElbows,
      Leaf_Filter_Sheet_size_details: leafFilterSheet?.costPricing?.sizes,
      Leaf_Filter_Sheet_versa_Max_Quantity: leafFilterSheet?.costPricing?.versaMaxQuantity,
      Leaf_Filter_Sheet_fastener_Type: leafFilterSheet?.costPricing?.fastenerType,
    },
    Leaf_Filter_Sheet_retailPrice: leafFilterSheet?.RetailPrice,
    Leaf_Filter_Sheet_parPrice: leafFilterSheet?.parPrice,
    Leaf_Filter_Sheet_costPrice: leafFilterSheet?.costPrice,
    Leaf_Filter_Sheet_Images: leafFilterSheet?.images || [],

  },
  interstitial: {
    modifyGutterHeight: leadDetail?.installationDetails?.requireGutterHeightModification,
    totalGutterFootageToBeLowered:leadDetail?.installationDetails?.requireGutterHeightModification ?  leadDetail?.installationDetails?.gutterLoweringFootage : 0,
    miscLeafFilter: {
      spoutSavers: leadDetail?.installationDetails?.spoutSaversCount || 0,
      copperAccessoryFootage:leadDetail?.installationDetails?.copperAccessoriesFootage || 0,
    },
    extraLabor: {
      hours: leadDetail?.installationDetails?.extraLaborHours || 0,
      reason: leadDetail?.installationDetails?.extraLaborReason || "N/A",
    },
    shingleOverhang: leadDetail?.installationDetails?.cutRemoveShingleOverhangFootage || 0,
    dripEdgeFlashingFootage: leadDetail?.installationDetails?.dripEdgeFlashingFootage || 0,
    fortyFootLadderNeeded: leadDetail?.installationDetails?.fortyFootLadderNeeded || 0,
    requiresHarnessWork: leadDetail?.installationDetails?.requiresHarnessWork || false,
    needsWalkboards: leadDetail?.installationDetails?.walkboardsNeeded || false,
    walkboardLength:leadDetail?.installationDetails?.walkboardLength  || '',
    reasonForWalkboards:leadDetail?.installationDetails?.walkboardReason  || '',
    attachments:leadDetail?.installationDetails?.images || []
    ///missing some fields
  },
  images: transformImages(leadDetail?.images),
};
return payload;
}

